import {
  STOCK_TAKING_CAR_MANAGEMENT_CLEAR_FAST_STOCK_LOADING_BEGIN,
  STOCK_TAKING_CAR_MANAGEMENT_CLEAR_FAST_STOCK_LOADING_SUCCESS,
  STOCK_TAKING_CAR_MANAGEMENT_CLEAR_FAST_STOCK_LOADING_FAILURE
} from '../constants'

export function clearFastStockLoading() {
  return (dispatch, getState) => {
    dispatch({
      type: STOCK_TAKING_CAR_MANAGEMENT_CLEAR_FAST_STOCK_LOADING_BEGIN
    })

    try {

      dispatch({
        type: STOCK_TAKING_CAR_MANAGEMENT_CLEAR_FAST_STOCK_LOADING_SUCCESS,
      })

    } catch (err) {
      dispatch({
        type: STOCK_TAKING_CAR_MANAGEMENT_CLEAR_FAST_STOCK_LOADING_FAILURE,
        data: err?.message
      })
    }
  }
}
